import { render, staticRenderFns } from "./PreNegotiationGenerateRemittance.vue?vue&type=template&id=33c1c69a&scoped=true"
import script from "./PreNegotiationGenerateRemittance.vue?vue&type=script&lang=ts"
export * from "./PreNegotiationGenerateRemittance.vue?vue&type=script&lang=ts"
import style0 from "./PreNegotiationGenerateRemittance.vue?vue&type=style&index=0&id=33c1c69a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c1c69a",
  null
  
)

export default component.exports